type DurationFormat = 'schedule' | 'picker'

const formatDurationParts = (hours: number, minutes: number, format: DurationFormat): string => {
    const formattedHours = format === 'picker' ? String(hours).padStart(2, '0') : String(hours)
    return `${formattedHours}:${String(minutes).padStart(2, '0')}`
}

const decimalHoursToMinutes = (decimalHours: number): number => Math.round(decimalHours * 60)

export const formatDecimalHours = (decimalHours: number, format: DurationFormat): string => {
    if (!Number.isFinite(decimalHours) || decimalHours < 0) {
        const hours = Math.floor(decimalHours)
        const minutes = Math.round((decimalHours - hours) * 60)
        return formatDurationParts(hours, minutes, format)
    }

    const totalMinutes = decimalHoursToMinutes(decimalHours)
    return formatDurationParts(Math.floor(totalMinutes / 60), totalMinutes % 60, format)
}

export const formatOptionalDecimalHoursForSchedule = (duration: unknown): string | null => {
    if (duration === null || duration === undefined || duration === '') return null

    const decimalHours = Number(duration)
    if (!Number.isFinite(decimalHours) || decimalHours < 0) return null

    return formatDecimalHours(decimalHours, 'schedule')
}

export const decimalHoursToPickerDuration = (duration: string | null | undefined): string => {
    if (!duration) return ''
    return formatDecimalHours(Number.parseFloat(duration), 'picker')
}

export const pickerDurationToDecimalHours = (value: string | null): string | null => {
    if (!value) return null

    const [hours, minutes] = value.split(':').map(Number)
    return ((hours * 60 + minutes) / 60).toFixed(2)
}

export const parseDurationToDecimalHours = (value: unknown): number => {
    if (typeof value === 'number') {
        if (!Number.isFinite(value)) return 0
        return value < 0 ? value : decimalHoursToMinutes(value) / 60
    }
    if (typeof value !== 'string') return 0

    const trimmed = value.trim()
    if (!trimmed) return 0

    const decimalHours = Number(trimmed)
    if (Number.isFinite(decimalHours)) {
        return decimalHours < 0 ? decimalHours : decimalHoursToMinutes(decimalHours) / 60
    }

    const hhmmMatch = trimmed.match(/^(\d{1,2}):(\d{1,2})$/)
    if (!hhmmMatch) return 0

    const hours = Number(hhmmMatch[1])
    const minutes = Number(hhmmMatch[2])
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0
    if (minutes < 0 || minutes > 59 || hours < 0) return 0

    return (hours * 60 + minutes) / 60
}
